import { inject } from '@angular/core';

import {
  CanActivateFn,
  CanActivateChildFn,
  Router
} from '@angular/router';

import { CookiesService }
from '../loginpage/cookies.service';


// ✅ COMMON FUNCTION
function checkAccess(route: any) {

  const router = inject(Router);

  const cookies = inject(CookiesService);

  const userData =
    cookies.getCookie('userData');

  // ❌ NO LOGIN
  if (!userData) {
    localStorage.clear();
   return router.createUrlTree(['/login']);
}

  const data =
    typeof userData === 'string'
      ? JSON.parse(userData)
      : userData;

  // ✅ USER ROLE
  const role =
    data.existing_role?.toLowerCase();

  // ✅ ROUTE ROLES
  const allowedRoles =
    route.data?.['roles'];

  // ✅ IF NO ROLE CONFIG
  if (!allowedRoles) {

    return true;

  }

  // ✅ ROLE MATCH
  if (allowedRoles.includes(role)) {

    return true;

  }

  return router.createUrlTree(['/login']);

  

}


// ✅ PARENT ROUTE GUARD
export const authGuard: CanActivateFn =
(route, state) => {

  return checkAccess(route);

};


// ✅ CHILD ROUTE GUARD
export const authChildGuard: CanActivateChildFn =
(childRoute, state) => {

  return checkAccess(childRoute);

};